export const MY_ACCOUNT = "my account"
export const NAVIGATION = "navigation"
export const WISHLIST_SAVE = "wishlist save"
export const NEWEST_TO_OLDEST = "newest to oldest"
export const OLDEST_TO_NEWEST = "oldest to newest"
export const LISTS = "lists"
export const MY_LISTS = "my lists"
export const KOHLER = "kohler"
export const ACCOUNT_SETTINGS = "account settings"
export const SHARE_LIST = "share list"
export const ADD_T0_CART = "add to cart"
export const ADD_ALL_T0_CART = "add all to cart"
export const LIST_DETAIL = "detail"
export const CLICK = "click"
export const LIST_DETAILS = "lists details"
export const SELECTED_LISTS = "selected lists"
